import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {PlayerModel} from './player.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'teamId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',

  players: 'players',
};

export class TeamModel extends Model {
  name!: string;
  createdAt!: Date;
  updatedAt!: Date;

  players!: PlayerModel[];

  get label(): string | null {
    if (this.name) {
      return this.name;
    }

    if (this.players.length) {
      return this.players[0].fullName;
    }

    return null;
  }

  get teamAvatar(): number | null {
    if (this.name) {
      return this.id;
    }

    return null;
  }

  get playerAvatar(): number | null {
    if (!this.name && this.players.length) {
      return this.players[0].id;
    }

    return null;
  }

  static getInstance(data: Params): TeamModel {
    const model = new TeamModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'players') {
        if (Array.isArray(data[propsMapping[prop]])) {
          (model as Params)[prop] = data[propsMapping[prop]].map((item: Params): PlayerModel => {
            return PlayerModel.getInstance(item);
          });
        }
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    if (!Array.isArray(model.players)) {
      model.players = [];
    }

    return model;
  }

  // static search(
  //   apiService: ApiService,
  //   urlParams?: HttpParams
  // ): Observable<ListState<TeamModel>> {
  //   return apiService
  //     .get('players', urlParams)
  //     .pipe(
  //       map((data: Params): ListState<TeamModel> => {
  //         const list: TeamModel[] = data['data'].map((item: Params): TeamModel =>
  //           TeamModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
